module.exports = __webpack_public_path__ + "media/application/images/ui/icon-masthead-mask-tint-yellow-a0b2d662348c93fc0c22b9a763b1ae31.png";